import { Divider } from "@mui/material";
import Button from "@mostrans/web-components/components/base/Button";
import React from "react";
import { KEY_PERCOBAAN } from "./../constant";
import { sort } from "../../../../../shared/helpers";

const ResultSimulation = ({ props }) => {
  const { key, nquestion, ids, values, handleStart } = props;
  const KeyImgs = (item) =>
    key.slice(0, +ids === 2 || +ids === 4 ? 5 : 6).map(function (name, i) {
      return (
        <li key={i} className="box__key">
          <label style={{ textAlign: "center" }}>
            <h5>{name}</h5>
            <img
              src={require("../../../../../components/Layout/assets/CFIT/Section " +
                ids +
                "/CONTOH " +
                `${item} ` +
                name +
                ".PNG")}
              alt={name}
              className="img-responsive"
              style={values[item - 1].includes(name) ? styles.answer : null}
            />
          </label>
        </li>
      );
    });
  return (
    <div className="container-fluid shadow-soft-s3 p-2">
      <div className="d-flex header">
        <h4>Hasil Simulasi Section {ids}</h4>
      </div>
      <Divider sx={{ marginY: "20px" }} />
      <div className="content ">
        {Array.apply(null, { length: nquestion[ids - 1] }).map((_, id) => (
          <>
            <div key={id} className="d-block wrapper m-auto shadow-soft-s1">
              <div className="d-grid text-center gap-1 my-2 py-2">
                <h5>Question {id + 1}</h5>
                {(() => {
                  if (+ids !== 2) {
                    return (
                      <div className="question__list m-auto">
                        <img
                          src={require("../../../../../components/Layout/assets/CFIT/Section " +
                            ids +
                            "/Contoh-soal-" +
                            (id + 1) +
                            ".png")}
                          alt={`Contoh Soal ${id + 1}`}
                        />
                      </div>
                    );
                  }
                })()}
                <div className="question__key m-auto">
                  <ul className="d-flex">{KeyImgs(id + 1)}</ul>
                </div>
                {(() => {
                  if (sort(values[id]) !== KEY_PERCOBAAN["KEY_SECTION_" + +ids][id]) {
                    return (
                      <span className="font-size-main">
                        Jawaban anda salah, {KEY_PERCOBAAN["KEY_SECTION_" + +ids][id]} adalah
                        jawaban yang benar
                      </span>
                    );
                  } else {
                    return <span className="font-size-main">Jawaban anda benar</span>;
                  }
                })()}
              </div>
            </div>
          </>
        ))}
      </div>
      <div className="footer text-center">
        <Button color="primary" variant="contained" onClick={() => handleStart()}>
          Mulai Section {ids}
        </Button>
      </div>
    </div>
  );
};

export default ResultSimulation;

const styles = {
  answer: { boxShadow: "0px 0px 8px 5px #0a8c4a", outline: "2px #0A8C4A" },
};
